
<!--
  Navigation bar
-->

<template lang="html">
  <div>

    <nav>
      <div class="container">
        <div class="row nav-top-row">

          <div id="nav-burger" @click="clickBurger" v-bind:class="{ 'active': panelOpen }">
     <!--        <img class="nav-burger-svg nav-svg-dark" :src="'static/img/common/burger_dark.svg'"  v-show="!panelOpen" type="image/svg+xml" />
            <img class="nav-burger-svg nav-svg-light" :src="'static/img/common/burger_light.svg'"  v-show="!panelOpen"  type="image/svg+xml" />

            <img class="nav-cross-svg nav-svg-dark" :src="'static/img/common/cross_dark.svg'"  v-show="panelOpen"  type="image/svg+xml" />
            <img class="nav-cross-svg nav-svg-light" :src="'static/img/common/cross_light.svg'"  v-show="panelOpen"  type="image/svg+xml" /> -->
            <div class="burger-bar burger-bar-2"></div>
            <div class="burger-bar burger-bar-1"></div>
            <div class="burger-bar burger-bar-3"></div>
          </div>

          <div class="top-bar"> <!-- v-bind:class="{ 'active': !hideMainMenu }"> -->
            <div class="nav-logo">
            <router-link to="/" v-if="pagename !== 'home'"><img class="nav-logo-png" :src="'static/img/common/logo.png'" /></router-link>
            <div v-scroll-to="'#top'" v-if="pagename == 'home'"><img class="nav-logo-png nav-logo-home" v-bind:class="{ 'active': hideMainMenu }" :src="'static/img/common/logo.png'" /></div>
          </div>

              <ul>   
                <li><router-link to="/about"><span v-bind:class=" { 'active': pagename === 'about' } " v-html="nav.about"></span></router-link></li>
                <li class="top-bar-dropdown-container" @mouseover="showDropdown = true" @mouseout="showDropdown = false">
                  <div class="top-bar-dropdown-button"><span v-html="nav.whatwedo"></span></div>
                  <div class="top-bar-dropdown-links" v-if="showDropdown">
                    <div class="top-bar-dropdown-link"><router-link to="/food"><span v-bind:class=" { 'active': pagename === 'food' } "v-html="nav.food"></span></router-link></div>
                    <div class="top-bar-dropdown-link"><router-link to="/projects"><span v-bind:class=" { 'active': pagename === 'projects' } " v-html="nav.projects"></span></router-link></div>
                    <!-- <div class="top-bar-dropdown-link"><router-link to="/canteen"><span v-bind:class=" { 'active': pagename === 'canteen' } " v-html="nav.canteen"></span></router-link></div> -->
                  </div>
                </li>
                <!-- <li><router-link to="/homeedition"><span v-bind:class=" { 'active': pagename === 'takeaway' } " v-html="nav.takeaway"></span></router-link></li> -->
                <li v-scroll-to="'#gallery-container'"><span v-html="nav.gallery"></span></li>
                <li v-scroll-to="'#contact-section'"><span v-html="nav.contact"></span></li>
              </ul> 
          </div>

          <div class="nav-panel" v-bind:class="{ 'active': panelOpen }">
            <div class="nav-panel-inner" v-bind:class="{ 'active': panelOpen }">
              <ul>
                <li v-if="pagename === 'home'" v-scroll-to="'#top'"><span v-bind:class=" { 'active': pagename === 'home' } " v-html="nav.home"></span></li>
                <li v-if="pagename !== 'home'"><router-link to="/"><span v-bind:class=" { 'active': pagename === 'home' } " v-html="nav.home"></span></router-link></li><br/>
                <li><router-link to="/about"><span v-bind:class=" { 'active': pagename === 'about' } " v-html="nav.about"></span></router-link></li><br/>
                <li><router-link to="/food"><span v-bind:class=" { 'active': pagename === 'food' } " v-html="nav.food"></span></router-link></li><br/>
                <li><router-link to="/projects"><span v-bind:class=" { 'active': pagename === 'projects' } " v-html="nav.projects"></span></router-link></li><br/>
                <!-- <li><router-link to="/homeedition"><span v-bind:class=" { 'active': pagename === 'takeaway' } " v-html="nav.takeaway"></span></router-link></li><br/> -->
                <li @click="clickNavPanel" v-scroll-to="'#gallery'"><span v-html="nav.gallery"></span></li><br/>
                <li @click="clickNavPanel" v-scroll-to="'#contact-section'"><span v-html="nav.contact"></span></li>
              </ul> 
            </div>
          </div>
        </div>
      </div>

    </nav>

    <div class="header-arrow" v-bind:class="{ 'active': !hideArrow && pagename !== 'about'  }">
      <img class="social-icon" :src="'static/img/common/left_dark.svg'" />
    </div>
  
  </div>
</template>

<style>

nav {
  width: 100%;
  z-index: 999;
  position: absolute;
} 
#nav-bar {

}
.nav-top-row {
  position: relative;
}
.logo-container {
  position: absolute;
  width: 100%;
  height: 100%;
}
.top-bar {
  position: fixed;
  width:100%;
  left:0;
  top:0px;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -webkit-transform: translate3d(0px, 0px, 0);
  transform: translate3d(0px, 0px, 0);
  background-color: rgba(255,255,255,0.95);
  height: 34px;
  list-style: 34px;
  display: none;
}
.top-bar ul {
  margin: 0 auto;
  padding: 0;
  text-align: center;
  list-style: none;
  height: 34px;
  line-height: 34px;
}
.top-bar li {
  display: inline-block;
  margin: 0 20px;
  line-height: 16px;
  -webkit-transition: all .1s ease;
  -moz-transition: all .1s ease;
  transition: all .1s ease;
  display: inline-block;
  color: #353230;
}
.top-bar-dropdown-container {
  position: relative;
  text-align: left;
}
.top-bar-dropdown-button {
  position: relative;
}
.top-bar-dropdown-links {
  padding: 0 10px;
  background-color: rgba(255,255,255,0.95);
  position: absolute;
  -webkit-transform: translate3d(-10px, 0px, 0);
  transform: translate3d(-10px, 0px, 0);
  margin-top: 0px;
}
.top-bar-dropdown-link  {
  display: inline-block;
  height: 34px;
  line-height: 34px;

}
.top-bar-dropdown-link:first-child{
  margin-top: 9px;
}

.nav-logo {
  position: absolute;
  margin: 5px;
  display: block;
  z-index: 3;
  cursor: pointer;
  top: 0;
  margin-left: 5%;
  height: 24px;
}
.nav-logo-home {
  opacity: 0;
}
.nav-logo-home.active {
  opacity: 1!important
}
.nav-logo-png {
  position: absolute;
  -webkit-transition: all 0.6s ease;
  transition: all 0.6s ease;
  height: 100%;
  width: auto;
}
.nav-logo-svg-dark {
  opacity: 1;
}
.nav-logo-svg-light {
  opacity: 0;
}
.nav-logo:hover > .nav-svg-dark  {
  opacity: 0!important
}
.nav-logo:hover > .nav-svg-light  {
  opacity: 1!important
}
.nav-panel {
  z-index: 1;
  position: fixed;
  width:0;
  overflow: hidden;
  height:300px;
  right: 0;
  top:0;
  width:200px;
  transition: all .3s ease;
  -webkit-transition: all .3s ease;
  -webkit-transform: translate3d(200px, 0px, 0)!important;
  transform: translate3d(200px, 0px, 0)!important;
/*  box-shadow: 8px 8px 0px #ec7d8d;*/
  text-align: center;
}
.nav-panel-in {
  -webkit-transform: translate3d(0px, 0px, 0)!important;
  transform: translate3d(0px, 0px, 0)!important;
}
.nav-panel.active {
  -webkit-transform: translate3d(0px, 0px, 0)!important;
  transform: translate3d(0px, 0px, 0)!important;
}
.nav-panel-inner {
  width:100%;
  height:100%;
  background-color: #fff;
  border: 1px solid #d1a699;
  transition: all .3s ease;
  -webkit-transition: all .3s ease;
  -webkit-transform: translate3d(0%, 0, 0);
}
.nav-panel-inner.active {
  -webkit-transform: translate3d(0%, 0, 0);
}
.nav-panel-inner ul {
  top:50%;
  width:100%;
  position: absolute;
  -webkit-transform: translate3d(0, -50%, 0);
}

.top-bar ul,
.nav-panel-inner ul {
  padding: 0;
}

.top-bar li,
.nav-panel-inner li {
  font-family: 'letter-gothic-std', "Helvetica Neue", Helvetica, Arial, sans-serif;
  letter-spacing: 0;
  font-weight: bold;
  list-style: none;
  font-size: 12px;
  text-transform: uppercase;
  cursor: pointer;
  margin: 8px 0;
  color: #353230;
}
.top-bar li a,
.nav-panel-inner li a {
  color: #353230;
  text-decoration: none;
}
.nav-panel-inner li {
  display:  inline-block;
}
.nav-panel-inner li a {
  color: #d1a699;
}

#nav-burger {
  position: fixed;
  right:0;
  z-index: 2;
  width: 30px;
  height: 30px;
  cursor: pointer;
  -webkit-transition: 0.2s ease-in-out;
  -webkit-transform: translate3d(0px,  0px, 0);
  transition: 0.2s ease-in-out;
  transform: translate3d(0px,  0px, 0);
/*  box-shadow: 5px 5px 0px rgba(0,0,0,1);*/
  background-color: #fff;
/*  border: 1px solid rgba(0,0,0,1);*/
  display: block;

}
/*.nav-burger-svg {
  position: absolute;
  top:3px;
  left:3px;
  width: 32px;
  height: 32px;
  -webkit-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
}
.nav-cross-svg {
  position: absolute;
  top:9px;
  left:9px;
  width: 22px;
  height: 22px;
  -webkit-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
}
.nav-svg-light {
  opacity: 0;
}*/
.burger-bar {
  width: 26px;
  height: 2px;
  left: 2px;
  top:0;
  background-color: #d1a699;
  position: absolute;
  border-radius: 2px;
  transform-origin: 50% 50%;
}
/*#nav-burger:hover {
  border: 1px solid #d1a699;
  box-shadow: 8px 8px 0px #ec7d8d;
}
#nav-burger:hover > .nav-svg-dark  {
  opacity: 0
}
#nav-burger:hover > .nav-svg-light  {
  opacity: 1
}*/

/*#nav-burger:hover > .burger-bar {
  background-color: #d1a699;
}
*/

.burger-bar-1 {
  -webkit-transform: translate3d(0px, 7px, 0) rotate(0deg);
  -webkit-transition: 0.3s ease-in-out;
}
.burger-bar-2 {
  -webkit-transform: translate3d(0px, 14px, 0) rotate(0);
  -webkit-transition: 0.3s ease-in-out;
}
.burger-bar-3 {
  -webkit-transform: translate3d(0px, 21px, 0) rotate(0);
  -webkit-transition: 0.3s ease-in-out;
}

#nav-burger.active {
/*  border: 1px solid rgba(0,0,0,0);
  background-color: transparent;
  box-shadow: 5px 5px 0px rgba(0,0,0,0);*/
}
#nav-burger.active > .burger-bar-1 {
  background-color: #fff;
  -webkit-transform: translate3d(0px, 14px, 0) rotate(135deg);
}
#nav-burger.active > .burger-bar-2 {
  -webkit-transform: translate3d(-2px, 0px, 0) rotate(0deg);
  width:30px;
  height:30px;
  background-color: #d1a699;
  border-radius: 0px;
/*  opacity: 0;*/
}
#nav-burger.active > .burger-bar-3 {
  background-color: #fff;
  -webkit-transform: translate3d(0px, 14px, 0) rotate(-135deg);
}

nav span {
  position: relative;
  display: block;
  cursor: pointer;
}

nav span:before, nav span:after {
  content: '';
  position: absolute;
  width: 0%;
  height: 3px;
  top: 50%;
  margin-top: -4px;
  background: #d1a699;
}

nav span:before {
  left: 0px;
}
nav span:after {
  right: 0px;
  background: #ec7d8d;
  transition: width 0.2s ease-in-out;
}

nav span:hover:before {
  background: #ec7d8d;
  width: 100%;
  transition: width 0.2s ease-in-out;
}

nav span:hover:after {
  background: transparent;
  width: 100%;
  transition: 0s;
}
nav span.active > nav span:before,
nav span.active:after  {
  width: 100%!important;
}


.header-arrow {
  position: absolute;
  bottom: 2px;
  left: 50%;
  margin-left: -12px;
  width:25px;
  height: 25px;
  animation: arrowBounceDown 1s infinite;
  -webkit-animation: arrowBounceDown 1s infinite;
  display: none
}
.header-arrow img {
  height: 25px;
  transform: rotateZ(270deg);
}

@keyframes arrowBounceDown {
  0% {transform: translate3d(0px, 0px, 0);} 
   30% {transform: translate3d(0px, 3px, 0);} 
}
@-webkit-keyframes arrowBounceDown {
  0% {-webkit-transform: translate3d(0px, 0px, 0);} 
   30% {-webkit-transform: translate3d(0px, 3px, 0);} 
}

@media (min-width: 576px) {
  .top-bar li {
    margin: 0 30px;
  }
}
@media (min-width: 768px) {
  .top-bar {
    display: block;
  }
  .nav-logo {
    display: block;
  }
  #nav-burger {
    display: none
  }
  .header-arrow.active {
    display: block
  }
  nav span:before, nav span:after {
    margin-top: -3px;
  }
  .nav-panel {
    display: none;
  }
}
@media (min-width: 992px) {
  .top-bar li {
    margin: 0 20px;
  }
}
@media (min-width: 1200px) {

}


</style>

<script>
import {commontools} from '../mixins/Styling'
import {nav} from '../../content.json'

var Vue = require('vue')
var VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 800,
  easing: 'ease',
  offset: -120,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

export default {
  name: 'navbar',
  mixins: [commontools],
  data () {
    return {
      pagetype: 0,
      hideMainMenu: false,
      panelOpen: false,
      pagename: '',
      nav,
      showDropdown: false,
      yTop: false,
      logoY: 0,
      hideArrow: false
    }
  },
  watch: {
    $route (to, from) {
      this.getNavParams()
    }
  },
  methods: {
    getNavParams () {
      if (this.pagename !== this.$route.name) this.panelOpen = false
      this.pagename = this.$route.name
    },
    clickBurger () {
      this.panelOpen = !this.panelOpen
    },
    clickNavPanel () {
      this.panelOpen = false
    },
    clickClose () {
      this.showMobileMenu = false
      this.getNavParams()
    },
    handleNavScroll () {
      this.percent = window.scrollY
      this.hideArrow = (this.percent >= 5)
      if (this.percent >= this.logoY) {
        this.hideMainMenu = true
      } else {
        this.hideMainMenu = false
        // this.panelOpen = false
      }
    },
    handleResize () {
      this.logoY = window.innerHeight / 2
    }
  },
  created () {
    window.addEventListener('scroll', this.handleNavScroll)
    window.addEventListener('resize', this.handleResize)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleNavScroll)
    window.removeEventListener('resize', this.handleResize)
  },
  mounted: function () {
    this.getNavParams()
    this.$nextTick(() => {
      this.handleResize()
    }, 10)
  },
  updated: function () {
  }
}

</script>



// WEBPACK FOOTER //
// Navbar.vue?57ebbf52